<template>

	<!-- Skylign -->

 	<b-container fluid class="sous_block">

    <b-container fluid id="hmm" class="mb-2"></b-container>
    <b-card
      id="card_info"
      style="width: 800px;"
      border-variant="primary"
      header-text-variant="white"
      header-class="header_col_info"
      align="center" class="mx-auto">
      <template #header>
        <b-row >
          <i class="fas fa-question-circle my-auto" v-b-tooltip.hover.top title="Click on a HMM logo column above to see its composition details."></i>
          <h6 class="title_card">Column informations</h6>
          <i v-b-toggle.accordion-col-info 
            @click="buttons = !buttons" 
            class="fa-1x fas" v-bind:class="[buttons ? 'fa-caret-square-down' : 'fa-caret-square-up']"></i>
        </b-row>
      </template>
      <b-collapse id="accordion-col-info" visible accordion="my-accordion-col-info" role="tabpanel">
        <b-col id="col_info"></b-col>
      </b-collapse>
    </b-card>
  
    
 	</b-container>
</template>
<script>
	export default {
 		props: {
 			domSelected: [String,Array],
      entryId: String,
      ck: Number,
      dom: String
 		},
        data(){
            return {
                hmmData: "null",
                buttons: true,
            }
        },
 		  mounted() {
          this.hmmData = this.domSelected
          this.get_hmm_json(this.hmmData)
          console.log('HMM LOGO Component mounted.')
	    },
	    watch: {
	      
    	},
    	methods:{
    		get_hmm_json(data){
          if ($.type(data) == 'string') {
            // console.log('string')
            axios
              .get("/main/get_hmm_json/"+this.hmmData)
              .then(response => (
                this.hmmData = response.data,
                this.create_hmm_logo(this.hmmData),
                this.pos_prot_to_pos_logo()
                ))       
          }else if ($.type(data[0].AA) === 'undefined'){
            console.log('AA(s) don\'t exist')
            this.create_hmm_logo(this.hmmData)
            this.pos_prot_to_pos_logo()
          }else if (data[0].AA){
            console.log('AA(s) exist')
            this.create_hmm_logo(data)
            this.pos_prot_to_pos_logo()
          }
    		},
    		pos_prot_to_pos_logo(){
          let key = this.ck
    			var pfid = [];
    			if ($.type(this.hmmData) === 'string') {
    				pfid = [this.hmmData]
    			}else{
    				pfid = this.hmmData
    			}
          if(typeof this.dom === "string"){
            pfid[0].pos_in_logo = 1
            //console.log('C\'est une string !') 
          }
          $(pfid).each(function(index, value){
            var id = '#logo'+key+'_'+index
            $(id+' .logo_position').val(value.pos_in_logo).change();
          });
    		},
        create_hmm_logo(data){
          let key = this.ck
          $(data).each(function(index){
             $('#hmm').append('<div class="logo_box" id="logobox_'+key+'_'+index+'" ><h2 class="ml-7 mt-2">Domain: <a href="http://pfam.xfam.org/family/'+data[index].pfid.toLowerCase()+'" target="_blank" >'+data[index].name_dom+' ('+data[index].name_complete.fontsize(5)+') - '+data[index].pfid+'</a></h2><div id="logo'+key+'_'+index+'" class="logo" data-logo=\''+data[index].hmm+'\'></div></div>');
            $('#logo'+key+'_'+index).hmm_logo({zoom: 1,column_info: "#col_info",id:key+"_"+index});

          });
        }
      
    	}
    }
</script>